import React, { useState, useEffect } from "react";
import axios from "axios";

const CourseContentLinks = ({ platformUrl }) => {
    const [linkItems, setLinkItems] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const courseUuid = params.get("courseUuid");

    useEffect(() => {
        if (!token || !courseUuid) {
            setError("Missing access token or course UUID. Please try again.");
            setLoading(false);
            return;
        }

        const fetchAllLinks = async () => {
            try {
                const courseRes = await axios.get(
                    `${platformUrl}/learn/api/public/v3/courses/uuid:${courseUuid}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                const courseId = courseRes.data.id;

                const stack = ["ROOT"];
                const collected = [];

                while (stack.length > 0) {
                    const parentId = stack.pop();

                    const resp = await axios.get(
                        `${platformUrl}/learn/api/public/v1/courses/${courseId}/contents?parentId=${parentId}`,
                        { headers: { Authorization: `Bearer ${token}` } }
                    );

                    for (const item of resp.data.results) {
                        const type = item.contentHandler?.id || "unknown";

                        // 🔷 Skip test links
                        if (type === "resource/x-bb-asmt-test-link") {
                            continue;
                        }

                        // Determine the best link
                        let href = null;

                        if (item.contentHandler?.url) {
                            href = item.contentHandler.url;
                        } else if (item.links?.length > 0) {
                            href = platformUrl + item.links[0].href;
                        }

                        if (href) {
                            collected.push({
                                id: item.id,
                                title: item.title,
                                type,
                                url: href
                            });
                        }

                        if (item.hasChildren) {
                            stack.push(item.id);
                        }
                    }
                }

                setLinkItems(collected);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAllLinks();
    }, [platformUrl, courseUuid, token]);

    if (loading) {
        return <div>Loading course links…</div>;
    }

    if (error) {
        return (
            <div className="bb-container bb-error">
                <h1>Error</h1>
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div className="bb-container">
            <h1>Course Linkable Content</h1>
            {linkItems.length === 0 ? (
                <p>No linkable content found.</p>
            ) : (
                <ul className="bb-list">
                    {linkItems.map((item) => (
                        <li key={item.id}>
                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                {item.title}
                            </a>{" "}
                            <em>({item.type})</em>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CourseContentLinks;
